module.exports = "/next-static/_next/static/images/block_image_be_everywhere-698ff8409eec480ae6be5b779ed4e565.png";